import { parseAuthError } from "../../../shared/helpers/api-helper-b";
import jobStatus from "../../../shared/variables/job-status";

import {
  CREATE_PROFILE,
  CREATE_PROFILE_SUCCESS,
  CREATE_PROFILE_FAILED,
} from "../actions";

const initialState = {
  status: jobStatus.NOT_STARTED,
  successMessage: undefined,
  error: undefined,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CREATE_PROFILE:
      return {
        ...state,
        status: jobStatus.PROCESSING,
      };
    case CREATE_PROFILE_SUCCESS: {
      return {
        ...state,
        status: jobStatus.SUCCESS,
        successMessage: payload.success,
      };
    }
    case CREATE_PROFILE_FAILED: {
      return {
        ...state,
        status: jobStatus.FAILED,
        error: parseAuthError(payload?.errors),
      };
    }
    default:
      return state;
  }
};
